import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext, M_Table, NavigateContext } from 'src/components/M_Components'

export default function TemplateList({ roles }) {
    const [refresh, setRefresh] = useState(false)
    const bufferServiceTemplateEmail = new BufferService('NotificationTemplate')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createTemplate', t("CreateTemplate"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('createTemplate', t("EditTemplate"))
            return
        }
    }

    const NewRouteContext = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createTemplate', t("CreateTemplate"))
            return
        }
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }

        if (operation === 'edit') {
            ctx2.newTab('createTemplate', t("EditTemplate"))
            return
        }
    }

    const menuTable = (Type) => {
        const nameForRole = 'templateEmail'
        const tempPerm = []
        const permLines = []
        const permButtons = []
        roles.forEach((role) => {
            if (role.match(nameForRole)) tempPerm.push(role.split(nameForRole)[1])
        })
        if (tempPerm.includes('Create')) {
            //add Template
            permLines.push({ label: t("Add"), icon: 'pi pi-plus-circle', command: (data) => NewRouteContext('', '', 'create', data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Add")}</div>, element: 'default', source: '/icons/svgsDaNet/add-circle.svg', style: { filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', }, command: (data) => NewRoute('', '', 'create', data)
            })
        }

        if (tempPerm.includes('Edit')) {
            //edit Template
            permLines.push({ label: t("Edit"), icon: 'pi pi-pencil', command: (data) => NewRouteContext('', '', 'edit', data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Edit")}</div>, element: 'default', source: '/icons/svgsDaNet/edit.svg', style: { filter: 'invert(72%) sepia(44%) saturate(1833%) hue-rotate(12deg) brightness(104%) contrast(101%)' }, command: (data) => NewRoute('', '', 'edit', data)
            })
        }

        if (tempPerm.includes('Delete')) {
            //delete template
            permLines.push({ label: t("Delete"), icon: 'pi pi-trash', command: (data) => deleteTemplateContext(data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Delete")}</div>, element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(13%) sepia(91%) saturate(5396%) hue-rotate(351deg) brightness(95%) contrast(88%)', }, command: (data) => deleteTemplateLine(data)
            })
        }

        if (Type === 'Context') return permLines //context menu
        if (Type === 'Buttons') return permButtons //header table
    }

    const removeContextItems = ['View', 'Create', 'Edit', 'Print']

    const deleteTemplateContext = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        bufferServiceTemplateEmail.delete(tempData.Id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', 'Error deleting Template')
                return
            }
            ctx.toastMessages('success', '', 'Template Deleted')
            setTimeout(function () {
                setRefresh(true)
            }, 1000)
        })
    }

    const deleteTemplateLine = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        bufferServiceTemplateEmail.delete(tempData.Id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', 'Error deleting Template')
                return
            }
            ctx.toastMessages('success', '', 'Template Deleted')
            setTimeout(function () {
                setRefresh(true)
            }, 1000)
        })
    }

    return (
        <div className='backgroundForms'>

            <div>
                <M_Table
                    filtersOnTable
                    entityName={'NotificationTemplate'}
                    removeContextItems={removeContextItems}
                    extraButtons={menuTable('Buttons')}
                    lineContext={menuTable('Context')}
                    refresh={refresh}
                    setRefresh={setRefresh}

                />
            </div>
            <div className='dividerTables'></div>
        </div >
    )
}